import React from "react";
import Select from "react-select";
import { FiUpload } from "react-icons/fi";
import { MdAttachFile } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import {
  OBSERVATION_SEVERITY_OPTIONS,
  OBSERVATION_STATUS_OPTIONS,
  OBSERVATION_TYPE_OPTIONS,
  getObservationAttachmentName,
  getObservationAttachmentSizeLabel,
  getOptionByValue,
} from "./observationUtils";

function ObservationFormFields({
  formData,
  errors,
  departments,
  selectedDepartment,
  onInputChange,
  onDepartmentChange,
  fileInputRef,
  documents = [],
  isDocumentPopupOpen = false,
  onUploadClick,
  onFileInputChange,
  onToggleDocumentPopup,
  onCloseDocumentPopup,
  onDeleteDocument,
  isDocumentRemovable,
  showStatus = false,
}) {
  return (
    <div className="new-data-form">
      <div className="form-group">
        <label htmlFor="title">
          Title <span className="text-danger">*</span>
        </label>
        <div className="input-group">
          <input
            id="title"
            name="title"
            type="text"
            value={formData.title}
            onChange={onInputChange}
            placeholder="Enter observation title"
          />
        </div>
        {errors.title && <div className="error-message">{errors.title}</div>}
      </div>

      <div className="form-group-select">
        <label htmlFor="type">
          Type <span className="text-danger">*</span>
        </label>
        <Select
          id="type"
          options={OBSERVATION_TYPE_OPTIONS}
          value={getOptionByValue(OBSERVATION_TYPE_OPTIONS, formData.type)}
          className="select-input"
          onChange={(selectedOption) =>
            onInputChange({
              target: {
                name: "type",
                value: selectedOption ? selectedOption.value : "",
              },
            })
          }
          placeholder="Select type"
          isClearable
        />
        {errors.type && <div className="error-message">{errors.type}</div>}
      </div>

      <div className="form-group-select">
        <label htmlFor="severity">
          Severity <span className="text-danger">*</span>
        </label>
        <Select
          id="severity"
          options={OBSERVATION_SEVERITY_OPTIONS}
          value={getOptionByValue(
            OBSERVATION_SEVERITY_OPTIONS,
            formData.severity,
          )}
          className="select-input"
          onChange={(selectedOption) =>
            onInputChange({
              target: {
                name: "severity",
                value: selectedOption ? selectedOption.value : "",
              },
            })
          }
          placeholder="Select severity"
          isClearable
        />
        {errors.severity && (
          <div className="error-message">{errors.severity}</div>
        )}
      </div>

      <div className="form-group-select">
        <label htmlFor="department_id">Department</label>
        <Select
          id="department_id"
          options={departments}
          value={selectedDepartment}
          className="select-input"
          onChange={onDepartmentChange}
          placeholder="Select department"
          isClearable
          isSearchable
        />
        {errors.department_id && (
          <div className="error-message">{errors.department_id}</div>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="location">Location</label>
        <div className="input-group">
          <input
            id="location"
            name="location"
            type="text"
            value={formData.location}
            onChange={onInputChange}
            placeholder="Enter location"
          />
        </div>
        {errors.location && (
          <div className="error-message">{errors.location}</div>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="observer_name">Observed By</label>
        <div className="input-group">
          <input
            id="observer_name"
            name="observer_name"
            type="text"
            value={formData.observer_name}
            onChange={onInputChange}
            placeholder="Enter observer name"
          />
        </div>
        {errors.observer_name && (
          <div className="error-message">{errors.observer_name}</div>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="observed_date">
          Observed Date <span className="text-danger">*</span>
        </label>
        <div className="input-group">
          <input
            id="observed_date"
            name="observed_date"
            type="date"
            value={formData.observed_date}
            onChange={onInputChange}
          />
        </div>
        {errors.observed_date && (
          <div className="error-message">{errors.observed_date}</div>
        )}
      </div>

      {showStatus && (
        <div className="form-group-select">
          <label htmlFor="status">
            Status <span className="text-danger">*</span>
          </label>
          <Select
            id="status"
            options={OBSERVATION_STATUS_OPTIONS}
            value={getOptionByValue(
              OBSERVATION_STATUS_OPTIONS,
              formData.status,
            )}
            className="select-input"
            onChange={(selectedOption) =>
              onInputChange({
                target: {
                  name: "status",
                  value: selectedOption ? selectedOption.value : "",
                },
              })
            }
            placeholder="Select status"
            isClearable
          />
          {errors.status && (
            <div className="error-message">{errors.status}</div>
          )}
        </div>
      )}

      <div className="form-group">
        <label htmlFor="description">Description</label>
        <div className="input-group">
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={onInputChange}
            placeholder="Enter observation description"
            rows={5}
          />
        </div>
        {errors.description && (
          <div className="error-message">{errors.description}</div>
        )}
      </div>

      <div className="form-group-attachments">
        <div className="form-group">
          <label htmlFor="observation_attachments">Documents</label>
          <button type="button" className="challan-btn" onClick={onUploadClick}>
            <FiUpload /> Upload File
          </button>
          <input
            type="file"
            id="observation_attachments"
            ref={fileInputRef}
            onChange={onFileInputChange}
            style={{ display: "none" }}
            multiple
          />
          {documents.length > 0 && (
            <span
              className="inquiry-file-btn"
              onClick={onToggleDocumentPopup}
              style={{ height: "39px" }}
            >
              <MdAttachFile className="inquiry-file-icon" /> {documents.length}
            </span>
          )}
          {isDocumentPopupOpen && (
            <div className="attach-popup-amc1">
              <div className="attach-popup-contant">
                <div className="attachment-header">
                  <div className="attachment-header-content">Documents</div>
                  <button
                    type="button"
                    className="fiile-close-btn"
                    onClick={onCloseDocumentPopup}
                  >
                    <IoCloseOutline className="file-close-icon" />
                  </button>
                </div>
                {documents.length > 0 ? (
                  <div className="attach-scrroll-body">
                    {documents.map((document, index) => {
                      const removable = isDocumentRemovable
                        ? isDocumentRemovable(document)
                        : true;

                      return (
                        <div className="attach-popup-contant-body" key={index}>
                          <div className="attach-file-container">
                            <div className="attach-file-show">
                              <div className="text-attachment">
                                {getObservationAttachmentName(document)}
                              </div>
                              <div className="text-attachment-file">
                                File Size: (
                                {getObservationAttachmentSizeLabel(document)})
                                {!removable ? " | Already uploaded" : ""}
                              </div>
                            </div>
                            {removable && (
                              <div
                                className="file-delete-btn"
                                onClick={() => onDeleteDocument?.(index)}
                              >
                                <span>
                                  <IoCloseOutline className="file-close-icon" />
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="observation-empty-state">
                    No documents selected
                  </div>
                )}
              </div>
            </div>
          )}
          {errors.documents && (
            <div className="error-message">{errors.documents}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ObservationFormFields;
